/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useEffect,
  useRef,
  useState,
} from 'react';

import _ from "lodash";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import SVG from 'react-inlinesvg';
import {
  toAbsoluteUrl,
} from '../../../_metronic/helpers';

import LoadingContent from '../../modules/loading/LoadingContent';
import { ListBranchCoupons } from '../Coupon/ListBranchCoupons';
import PaymentPage from '../Payment/PaymentPage';
import { FilterField } from './FilterField';

import {
  calculateDates,
  parseWeekDays,
} from '../../services/dates';

import {
  formatMoney,
} from '../../services/intFormat';

import {
  fetchBranchAvailableDays,
  fetchBranchFields,
} from '../../services/branches';

import {
  fetchBranchCoupons,
} from '../../services/coupons';

import {
  trackViewItem,
  buildEcommerceParams,
} from '../../services/analytics';

const CreateSchedule = ({branch}) => {
  const { branches, auth, coupons } = useSelector((state : any) => ({
    branches: state.branches,
    auth: state.auth,
    coupons: state.coupons,
  }), shallowEqual);

  const location :any = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const timeRef = useRef<any>();
  const goToCheckoutRef = useRef<any>();

  const [selectedDate, setSelectedDate] = useState<any>('');
  const [dates, setDates] = useState<any>([]);
  const [filteredFields, setFilteredFields] = useState<any>('');
  const [selectedFields, setSelectedFields] = useState<any>([]);
  const [selectedCoupon, setSelectedCoupon] = useState<any>({});
  const [activeTime, setActiveTime] = useState<any>({});
  const [activeHour, setActiveHour] = useState<any>({});
  const [activeHourIndex, setActiveHourIndex] = useState<any>();
  const [activeService, setActiveService] = useState<any>({});
  const [activeField, setActiveField] = useState<any>({});
  const [openFilterField, setOpenFilterField] = useState<any>(false);
  const [openPayment, setOpenPayment] = useState<any>(false);
  const [openListBranchCoupons, setOpenListBranchCoupons] = useState<any>(false);
  const [showRules, setShowRules] = useState<boolean>(false);

  useEffect(() => {
    let getDates = calculateDates();

    setDates(getDates);
    setSelectedDate(getDates[0]);

    if(branch && branch.attributes && branch.attributes.partner_id && getDates[0]) {
      fetchBranchFields(branch.attributes.partner_id).then((value) => {
        setFilteredFields(value)
      });
    }
  }, [branch]);

  useEffect(() => {
    if(branch?.attributes?.partner_id && selectedDate) {
      dispatch<any>(fetchBranchAvailableDays(
        branch.attributes.partner_id,
        selectedDate.value,
        null,
        selectedCoupon ? selectedCoupon.id : null,
        selectedFields
      ));

      setSelectedCoupon({});

      setActiveTime({});
      setActiveHourIndex('');
      setActiveHour({});
      setActiveService({});
      setActiveField({});
    }
  }, [selectedDate]);

  const navigateToLogin = () => {
    navigate({}, { state: { login: location } })
  }

  const selectActiveTime = (value) => {
    setActiveTime(value);

    setActiveHourIndex(0);
    setActiveHour(value.attributes.durations[0]);
    setActiveService({});
    setActiveField({});

    setTimeout(() => {
      if (timeRef && timeRef.current && timeRef.current.offsetTop) {
        timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 100)
  };

  const selectActiveService = (value) => {
    setActiveService(value);

    trackViewItem(buildEcommerceParams({
      id: value.id,
      name: value.name,
      price: value.price ?? 0,
      itemBrand: branch?.attributes?.name,
      itemVariant: 'single',
      coupon: selectedCoupon?.id && !value.coupon_disabled ? selectedCoupon : null,
      purchaseType: 'schedule',
    }));

    setTimeout(() => {
      if (goToCheckoutRef && goToCheckoutRef.current && goToCheckoutRef.current.offsetTop) {
        goToCheckoutRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 100)
  };

  const selectCoupon = (value, defaultDay = null) => {
    setSelectedCoupon(value);
    dispatch<any>(fetchBranchAvailableDays(
      branch.attributes.partner_id,
      selectedDate.value,
      null,
      value.id,
      selectedFields
    )).then((data) =>
      reloadServicePriceByCoupon(data, defaultDay)
    );
  }

  const reloadFields = (value) => {
    setSelectedFields(value);

    dispatch<any>(fetchBranchAvailableDays(
      branch.attributes.partner_id,
      selectedDate.value,
      null,
      selectedCoupon ? selectedCoupon.id : null,
      value
    ));
  }

  const reloadServicePriceByCoupon = (data, defaultDay: any = null) => {
    data.map((days) => {
      days.map(day => {
        let current = defaultDay ? defaultDay.id : activeTime.id;

        if (day.id == current) {
          setActiveTime(day);

          setActiveHourIndex(0);
          setActiveHour(day.attributes.durations[0]);
          setActiveService({});
          setActiveField({});
        }
      })
    })
  }

  const nextStep = () => {
    if (!auth.user) {
      navigateToLogin();
      return
    }

    if (auth.user && !auth.user?.phone) {
      navigate({}, { state: { verifyPhoneUrl: location } });
      return
    }

    setOpenPayment(true);
  }

  const parseValue = (value, type) => {
    let message = 'R$ ' + value;

    if (type === 'percentage') {
      message = value + '% na compra';
    }

    return message;
  }

  useEffect(() => {
    if (branch?.id && auth?.user?.id && selectedDate?.value && activeTime?.id) {
      dispatch<any>(fetchBranchCoupons(branch.attributes.partner_id, 'single', 'reservation', selectedDate.value + ' ' + activeTime.id));
    }
  }, [branch, auth?.user?.id, selectedDate.value, activeTime.id]);

  return (
    <>
      <div className="flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row min-h-900px">
          <div className="flex-lg-row-fluid mb-10 mb-lg-0">
            <div className="bg-body flex-lg-row-fluid flex-center rounded-4 p-10 h-100">
              <div className="mb-13 text-center">
                <h1 className="mb-3">
                  Locação de quadra
                </h1>
                <div className="text-muted fw-semibold fs-5">
                  Reserve uma quadra para jogar com seus amigos.
                </div>
                <div className="text-muted fw-semibold fs-5">
                  Selecione um horário e garanta sua reserva!
                </div>
              </div>

              <ul className="nav nav-pills d-flex flex-md-nowrap hover-scroll-x py-2">
                {dates.map((date) => <li className="nav-item me-1">
                  <a
                    className={`nav-link btn d-flex flex-column flex-center rounded-pill min-w-40px me-2 py-4 btn-active-primary ` + (date.value == selectedDate.value && `active`)}
                    data-bs-toggle="tab"
                    onClick={() => setSelectedDate(date)}
                  >
                    <span className="opacity-50 fs-7 fw-semibold">{date.weekday}</span>
                    <span className="fs-6 fw-bolder">{date.date}</span >
                  </a>
                </li>)}
              </ul>

              <div className="d-flex flex-column">
                {branches.availableDays.status == 'requested' && <LoadingContent />}
                {branches.availableDays.status == 'completed' && <div className="row mt-5">
                  <div className="col-lg-12 pb-10">
                    <a
                      className={`cursor-pointer ${selectedFields.length > 0 && 'text-primary'}`}
                      onClick={() => setOpenFilterField(true)}
                    >
                      <h4 className={`text-white text-hover-primary text-end ${selectedFields.length > 0 && 'text-primary'}`}>
                        Filtrar quadra {selectedFields.length > 0 && `(${selectedFields.length})`}
                      </h4>
                    </a>
                  </div>
                  <div className="col-lg-12 mb-10 mb-lg-0">
                    <ul className="nav nav-pills nav-pills-custom mb-3 justify-content-center">
                      {branches.availableDays.data.length > 0 && branches.availableDays.data.map((days, index2) => <>
                        {days.map((day, index )=> <li className="position-relative nav-item mb-3 me-3 me-lg-6">
                          <a
                            className={`nav-link btn btn-outline btn-outline-primary btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-55px pt-5 pb-2 ${day.attributes.durations.length === 0 ? 'disabled' : ''} ${activeTime.id === day.id ? 'active' : ''}`}
                            onClick={() => selectActiveTime(day)}
                            id={day.id}
                          >
                            <span className={`nav-text text-white fw-bold fs-6 lh-1 ${day.attributes.durations.length == 0 && 'lineThrough text-gray-400'}`}>{day.id}</span>
                            <span className="bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"></span>
                          </a>
                        </li>)}
                      </>)}
                    </ul>

                    {branches.availableDays.data.length == 0 && <div className="mb-13 text-center">
                      <h2 className="mb-3">
                        Ops, nenhum horário disponível!
                      </h2>
                      <div className="text-muted fw-semibold fs-5">
                        Parece que campo não está com agendamento online aberto na data selecionada.
                      </div>
                      <div className="text-muted fw-semibold fs-5">
                        Selecione outra data para continuar!
                      </div>
                    </div>}
                  </div>
                </div>}
              </div>
            </div>
          </div>
          {activeTime.id && <div className="flex-lg-auto min-w-lg-400px ms-lg-10">
            <div
              className="card card-flush pt-3 mb-0 position-sticky top-7"
              ref={timeRef}
            >
                <div className="card-body pt-3 fs-6">
                  {activeTime.id && <>
                      <div className="mb-5">
                        <h1 className="mb-3 text-center">
                          Cupom de desconto
                        </h1>
                        <div className="text-muted fw-semibold fs-5 text-center">
                          Veja os cupons disponíveis para o horário selecionado e aproveite
                        </div>

                        <div className="d-flex justify-content-center">
                          <div
                            className={`
                              card card-dashed flex-row flex-wrap py-5 my-5 cursor-pointer mw-400px w-100 ${selectedCoupon.id && activeService.coupon_disabled && `border-warning border border-dashed`}`}
                            onClick={() => auth.user ? setOpenListBranchCoupons(true) : navigateToLogin()}
                          >
                            {/*<img src={toAbsoluteUrl(`/media/custom/coupons.png`)} width="40" height="40" className="mx-5 align-self-center" />*/}
                            <SVG src={toAbsoluteUrl('/media/svg/custom/coupons.svg')} width="40" height="40" className="mx-5 align-self-center text-white" fill="white" />
                            <div className="d-flex flex-column pe-7">
                                <div className="d-flex align-items-center fs-4 fw-bold mb-1">
                                  {!selectedCoupon.id && `Cupom de desconto`}
                                  {selectedCoupon.id && selectedCoupon.attributes.name}
                                </div>
                                <div className="d-flex align-items-center fs-5 fw-semibold text-gray-600">
                                  {selectedCoupon.id && <>
                                    {activeService.coupon_disabled && 'Cupom não aplicado'}
                                    {!activeService.coupon_disabled && 'Cupom aplicado'}
                                  </>}

                                  {!selectedCoupon.id && <>
                                    {!selectedCoupon.id && coupons?.entities?.length > 0 ?
                                      `${coupons.entities.length} ${coupons.entities.length == 1 ? "disponível" : "disponíveis"}`
                                     : auth.user ? `Nenhum disponível` : `Fazer login`}
                                  </>}
                                </div>
                                <i className="position-absolute end-0 mt-5 me-5 las la-angle-right fs-2x text-white"></i>
                            </div>
                          </div>
                        </div>
                        {selectedCoupon && selectedCoupon.id && <>
                          <span
                            className="cursor-pointer text-primary fs-6"
                            onClick={() => setShowRules(!showRules)}
                          >
                            {showRules ? "Ocultar regras" : "Ver regras"}
                          </span>

                          {showRules && <div className="pt-3">
                            {selectedCoupon?.attributes?.weekdays?.length > 0 && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                              • Válido de {parseWeekDays(selectedCoupon.attributes.weekdays)}
                            </div>}
                            {selectedCoupon?.attributes?.start_at && selectedCoupon?.attributes?.end_at && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                              • Entre os horários das {selectedCoupon.attributes.start_at} até {selectedCoupon.attributes.end_at}
                            </div>}
                            <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                              • Desconto de {selectedCoupon && selectedCoupon.attributes && parseValue(selectedCoupon.attributes.value, selectedCoupon.attributes.type)}
                            </div>
                            {selectedCoupon.relationships?.coupon_restrictions?.length > 0 && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                              • Válido para {_.map(selectedCoupon.relationships.coupon_restrictions,'relationships.origin.attributes.name').join(",")}
                            </div>}
                          </div>}
                        </>}
                      </div>
                      <div className="col-lg-12 mb-10 mb-lg-0">
                        <div className="mb-5 mt-10 text-center">
                          <h4 className="mb-3">
                            Quantas horas você vai jogar?
                          </h4>
                        </div>

                        <ul className="nav nav-pills d-flex justify-content-center nav-pills-custom gap-3 mb-0">

                          {activeTime.attributes.durations.map((duration, index) => <li className="nav-item mb-3 me-5">
                            <a
                              className={`nav-link nav-link-border-solid btn btn-outline btn-flex btn-active-color-primary flex-column flex-stack pt-9 pb-7 page-bg show ${activeHourIndex == index && 'active'}`}
                              data-bs-toggle="pill"
                              onClick={() => {
                                setActiveHourIndex(index)
                                setActiveHour(duration)
                                setActiveService({});
                                setActiveField({});
                              }}
                            >
                              <div className="">
                                <span className="text-gray-800 fw-bold fs-4 d-block">{duration.id}</span>
                                <span className="text-gray-400 fw-semibold fs-7">HORAS</span>
                              </div>
                            </a>
                          </li>)}
                        </ul>
                      </div>
                    </>}

                    {activeHour && activeHour.id && <div className="col-lg-12 mb-10 mb-lg-0">
                      {activeHour.fields.map((field) => <>
                        <div className="m-0 cursor-pointer mt-5" data-bs-toggle="collapse" data-bs-target={`#field-${field.id}`}>
                          <div className="d-flex collapsible py-3 toggle collapsed mb-0" data-bs-toggle="collapse" data-bs-target={`#field-${field.id}`}>
                            <div className="btn btn-sm btn-icon mw-20px btn-active-color-primary me-5">
                              <span className="svg-icon toggle-on svg-icon-primary svg-icon-1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                  <rect x="6.0104" y="10.9247" width="12" height="2" rx="1" fill="currentColor" />
                                </svg>
                              </span>
                              <span className="svg-icon toggle-off svg-icon-1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                  <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor" />
                                  <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor" />
                                </svg>
                              </span>
                            </div>
                            <span>
                              <h4 className="text-gray-900 fw-bold cursor-pointer mb-0">{field.attributes.name}</h4>
                              <div className="text-muted fw-semibold cursor-pointer fs-5">
                                {field.attributes.ground_type}
                              </div>
                            </span>
                          </div>

                          <div id={`field-${field.id}`} className="collapse fs-6 ms-1 mb-5"  data-bs-toggle="collapse">
                            {field.relationships.services.map(service => <div className="w-lg-100" data-kt-buttons="true">
                              <label
                                className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-5 ${activeField.id == field.id && activeService.id == service.id && 'active'}`}
                                onClick={() => {
                                  setActiveField(field)
                                  selectActiveService(service)
                                }}
                              >
                                <div className="d-flex align-items-center me-2">
                                  <div
                                    className={`form-check form-check-custom form-check-primary-reverse form-check-success flex-shrink-0 me-6 ${(activeField.id === field.id && activeService.id === service.id) ? 'form-check-primary-reverse' : 'form-check-solid'}`}
                                  >
                                    <input className="form-check-input" type="radio" name="plan" checked={activeField.id === field.id && activeService.id === service.id} />
                                  </div>

                                  <div className="flex-grow-1">
                                    <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                                      {service.name}
                                    </h2>
                                  </div>
                                </div>

                                <div className="ms-5">
                                  {service.price == 0 && <span className="fs-2x fw-bold  text-gray-800">Grátis</span>}
                                  {service.price > 0 && <div className="flex-row">
                                    <div>
                                      <span className="mb-2">R$</span>
                                      <span className="fs-2x fw-bold">
                                        {formatMoney(service.price, false, false)}
                                      </span>
                                    </div>

                                    {service.price_total && service.price_total != service.price && <span className="d-flex lineThrough fs-7 text-gray-800 text-end">
                                      {formatMoney(service.price_total)}
                                    </span>}
                                  </div>}
                                </div>
                              </label>
                            </div>)}
                          </div>

                          <div className="separator separator-dashed"></div>
                        </div>
                      </>)}
                    </div>}

                  {selectedCoupon.id && activeService.coupon_disabled && <div
                    className={`
                      card card-dashed flex-row flex-wrap p-5 my-5 cursor-pointer mw-400px w-100 ${`border-warning border border-dashed`}`}
                  >
                    <span className="text-white">Cupom não aplicado</span>
                  </div>}
                  <div className="mb-0" ref={goToCheckoutRef}>
                    <button
                      className="btn btn-primary btn-lg cursor-pointer fw-bold w-100 mt-4"
                      disabled={!activeService.id}
                      onClick={() => nextStep()}
                    >
                      IR PARA PAGAMENTO
                    </button>
                  </div>
                </div>
              </div>
          </div>}
        </div>
      </div>

      <ListBranchCoupons
        isOpen={openListBranchCoupons}
        onClosed={() => setOpenListBranchCoupons(false)}
        onSelect={value => selectCoupon(value)}
        selectedCoupon={selectedCoupon.id}
        branchId={branch?.attributes?.partner_id}
        date={`${selectedDate?.value} ${activeTime?.id}`}
        sellingType="single"
        sellingModality="reservation"
      />

      <FilterField
        fields={filteredFields}
        selected={selectedFields}
        isOpen={openFilterField}
        onClosed={() => setOpenFilterField(false)}
        onSelect={value => reloadFields(value)}
      />

      <PaymentPage
        isOpen={openPayment}
        onClosed={() => setOpenPayment(false)}
        attributes={{
          type: "schedule",
          modality: "single",
          time: activeTime,
          day: selectedDate && selectedDate.value,
          hour: activeHour,
          service: activeService,
          field: activeField,
          branch: branch,
          item_variant: 'single',
          coupon: !activeService.coupon_disabled ? selectedCoupon : null,
        }}
      />
    </>
  )
}

export default CreateSchedule;
